export default __webpack_public_path__ + "static/media/CDR_logo.4755f11d.webp";